import React from "react";
import { RoutineListView } from "components/Routines/RoutineListView";

export const RoutineListScreen = () => {
  return <RoutineListView />;
};
